"use client";

import { dollarFormatter } from "@/features/analysis/utils/formatters";

import { BarChart, BarChartData, BarChartInfo } from "ui/analysis/bar-chart";

export const ClientBarChart = ({
  chartData,
  info,
}: {
  chartData: BarChartData[];
  info: BarChartInfo;
}) => (
  <BarChart
    data={chartData}
    info={info}
    yAxisWidth={35}
    yTicksFormatter={dollarFormatter}
    tooltipIconType="circle"
    legendProps={{
      formatter: (value) => <span className="text-zinc-500">{value}</span>,
      height: 56,
    }}
    showLegend
  />
);
